import confetti from 'canvas-confetti';

export class SecretScratchCard {
  constructor(canvasId, containerId) {
    this.canvas = document.getElementById(canvasId);
    this.container = document.getElementById(containerId);
    if (!this.canvas || !this.container) return;

    this.ctx = this.canvas.getContext('2d');
    this.isDrawing = false;
    this.isRevealed = false;
    this.brushSize = 32;
    this.kissCount = 1000;

    this.initCanvas();
    this.bindEvents();
    this.bindInteractionButtons();
  }

  initCanvas() {
    const rect = this.canvas.parentElement.getBoundingClientRect();
    this.width = rect.width || 480;
    this.height = rect.height || 260;

    this.canvas.width = this.width;
    this.canvas.height = this.height;

    // Fill Shimmering Rose Gold Foil Overlay
    const grad = this.ctx.createLinearGradient(0, 0, this.width, this.height);
    grad.addColorStop(0, '#D4AF37');
    grad.addColorStop(0.25, '#FFDF73');
    grad.addColorStop(0.5, '#E5A9B4');
    grad.addColorStop(0.75, '#D4AF37');
    grad.addColorStop(1, '#8C6A1A');

    this.ctx.fillStyle = grad;
    this.ctx.fillRect(0, 0, this.width, this.height);

    // Subtle inner gold foil border
    this.ctx.strokeStyle = 'rgba(255, 255, 255, 0.45)';
    this.ctx.lineWidth = 4;
    this.ctx.strokeRect(10, 10, this.width - 20, this.height - 20);

    // Decorative Text / Icon on the scratch surface
    this.ctx.fillStyle = '#2A0F17';
    this.ctx.font = '700 16px "Plus Jakarta Sans", sans-serif';
    this.ctx.textAlign = 'center';
    this.ctx.fillText('✨ Scratch Here to Unlock Secret Letter ✨', this.width / 2, this.height / 2 - 10);

    this.ctx.font = '500 13px "Plus Jakarta Sans", sans-serif';
    this.ctx.fillStyle = '#4A1521';
    this.ctx.fillText('💋 (Drag your finger or cursor across)', this.width / 2, this.height / 2 + 18);
  }

  bindEvents() {
    const start = (e) => {
      this.isDrawing = true;
      this.scratch(e);
    };

    const stop = () => {
      this.isDrawing = false;
      this.checkRevealed();
    };

    const move = (e) => {
      if (!this.isDrawing) return;
      this.scratch(e);
    };

    this.canvas.addEventListener('mousedown', start);
    window.addEventListener('mouseup', stop);
    this.canvas.addEventListener('mousemove', move);

    this.canvas.addEventListener('touchstart', (e) => {
      e.preventDefault();
      start(e.touches[0]);
    }, { passive: false });
    window.addEventListener('touchend', stop);
    this.canvas.addEventListener('touchmove', (e) => {
      e.preventDefault();
      move(e.touches[0]);
    }, { passive: false });
  }

  bindInteractionButtons() {
    const kissBtn = document.getElementById('btn-send-kiss');
    const hugBtn = document.getElementById('btn-tight-hug');
    const countEl = document.getElementById('live-kiss-count');

    if (kissBtn) {
      kissBtn.addEventListener('click', (e) => {
        this.kissCount += 10;
        if (countEl) countEl.textContent = `${this.kissCount.toLocaleString()}+ 💋`;
        this.spawnFloatingEmojis(['💋', '💖', '✨', '😘', '💕'], e.clientX, e.clientY);

        confetti({
          particleCount: 25,
          spread: 50,
          origin: {
            x: e.clientX / window.innerWidth,
            y: e.clientY / window.innerHeight
          },
          colors: ['#FF4D6D', '#FF758F', '#D4AF37']
        });
      });
    }

    if (hugBtn) {
      hugBtn.addEventListener('click', (e) => {
        this.kissCount += 5;
        if (countEl) countEl.textContent = `${this.kissCount.toLocaleString()}+ 💋`;
        this.spawnFloatingEmojis(['🫂', '❤️', '🌸', '✨', '🥰'], e.clientX, e.clientY);
      });
    }
  }

  spawnFloatingEmojis(emojis, originX, originY) {
    const count = 7;
    for (let i = 0; i < count; i++) {
      const span = document.createElement('span');
      span.className = 'floating-kiss-emoji';
      span.textContent = emojis[Math.floor(Math.random() * emojis.length)];
      span.style.left = `${(originX || window.innerWidth / 2) + (Math.random() - 0.5) * 80}px`;
      span.style.top = `${(originY || window.innerHeight / 2) + (Math.random() - 0.5) * 40}px`;
      span.style.fontSize = `${Math.random() * 1.2 + 1.2}rem`;
      document.body.appendChild(span);

      setTimeout(() => {
        span.remove();
      }, 1600);
    }
  }

  getPos(e) {
    const rect = this.canvas.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
  }

  scratch(e) {
    if (this.isRevealed) return;
    const pos = this.getPos(e);

    this.ctx.globalCompositeOperation = 'destination-out';
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, this.brushSize, 0, Math.PI * 2);
    this.ctx.fill();
  }

  checkRevealed() {
    if (this.isRevealed) return;

    const imageData = this.ctx.getImageData(0, 0, this.width, this.height);
    const pixels = imageData.data;
    let transparentCount = 0;
    const totalPixels = pixels.length / 4;

    for (let i = 3; i < pixels.length; i += 16) {
      if (pixels[i] === 0) {
        transparentCount += 4;
      }
    }

    const percentage = (transparentCount / totalPixels) * 100;

    if (percentage > 40) {
      this.isRevealed = true;
      this.canvas.style.transition = 'opacity 0.6s ease';
      this.canvas.style.opacity = '0';
      this.canvas.style.pointerEvents = 'none';

      // Confetti celebratory burst
      confetti({
        particleCount: 100,
        spread: 80,
        origin: { y: 0.6 },
        colors: ['#FF4D6D', '#FF8FA3', '#E5B869', '#FFE5D9', '#D4AF37']
      });
    }
  }
}
